module.exports = __webpack_public_path__ + "static/github-2e4d12af245feabb9720ed7569b87742.png";